import { createModel } from "hox"
import { useSetState } from "ahooks"

function useInsight() {
  const [insightState, setInsightState] = useSetState<any>({
    editing: false,
  })
  return {
    insightState,
    setInsightState,
  }
}
export default createModel(useInsight)
